import { SIDE_NAV_DEFAULT_THEMES } from "@performyard/utils-isomorphic";

/** Default side-nav theme used as the shell fallback until the company's saved selection loads. */
export const SIDE_NAV_PRIMARY_BLUE_THEME = {
	...SIDE_NAV_DEFAULT_THEMES.midnightBlue,
	isDefault: true,
} as const;
